import { ComparisonResult } from '@/components/atoms/comparisonResult';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';
import { Text } from '@/components/atoms/text';
import { useTranslation } from '@/hooks/useTranslation';
import { Flex } from '@/styles/globalStyles';
import type { ClassificationOpportunityAndRisk } from '@/types/classification';
import { legend } from '@/utils/functions/legends';

interface GenericChartProps {
  variant?: 'opportunity' | 'risk';
  chartData?: {
    title: string;
    classification: ClassificationOpportunityAndRisk;
    noTooltip?: boolean;
    data: {
      note: number | string;
      color: string;
    };
  }[];
}

export const GenericChart = ({ chartData, variant }: GenericChartProps) => {
  const { t } = useTranslation();

  const validItems = chartData?.filter(
    (item) => String(item.data.note) !== '0' && item.data.note !== null
  );

  if (!validItems || validItems.length === 0) {
    return (
      <Flex justify="center" align="center" fullWidth>
        <Text variant="subtitle1" color="text.disabled">
          <SafeMarkdown
            text={
              variant === 'opportunity'
                ? t('label.label.no_opportunity_calculated')
                : t('label.label.no_risk_calculated')
            }
          />
        </Text>
      </Flex>
    );
  }

  return (
    <>
      {validItems.map((item) => (
        <ComparisonResult
          key={item.title}
          title={item.title}
          comparison={item.data}
          noTooltip={item.noTooltip}
          tooltip={legend.legendByClassification({
            classification: item.classification,
            t,
          })}
        />
      ))}
    </>
  );
};
